export type { IAnimationStyles, IAnimationVariables } from '@fluentui/theme';
